import React from "react";
import { useSelector } from "react-redux";
import showdown from "showdown";
import classnames from "classnames";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(
    currentActivity.websiteData.aboutClient.subtitle
  );
  const description =
    currentActivity &&
    currentActivity.websiteData &&
    currentActivity.websiteData.aboutClient &&
    currentActivity.websiteData.aboutClient.data &&
    currentActivity.websiteData.aboutClient.data.description
      ? converter.makeHtml(
          currentActivity.websiteData.aboutClient.data.description
        )
      : "please complete the about client ";

  return (
    <>
      {currentActivity &&
        currentActivity.websiteData &&
        currentActivity.websiteData.aboutClient &&
        currentActivity.websiteData.aboutClient.data &&
        (currentActivity.websiteData.aboutClient.data.name ||
          currentActivity.websiteData.aboutClient.data.description) && (
          <div
            id="about"
            className="gradiant-background pwg-section about-section section pb-90 whitetxt"
          >
            <div className="container tab-fix">
              <div className="section-head text-center">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <h2 className="heading heading-light">
                      {`${
                        currentActivity &&
                        currentActivity.websiteData &&
                        currentActivity.websiteData.aboutClient &&
                        currentActivity.websiteData.aboutClient.title
                          ? currentActivity.websiteData.aboutClient.title
                          : "About the client"
                      }`}
                    </h2>
                    {currentActivity.websiteData.aboutClient.subtitle && (
                      <p
                        className="h4 heading-light"
                        dangerouslySetInnerHTML={{ __html: subtitle }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="row tab-center mobile-center col-md-12">
                <div className="col-md-6">
                  <div className="txt-entry">
                    <p
                      className="whitetxt"
                      style={{
                        color: "white",
                      }}
                      dangerouslySetInnerHTML={{ __html: description }}
                    ></p>
                  </div>
                </div>
                <div
                  className="col-md-6 centerBox connecter"
                  // style={{ height: "350px" }}
                >
                  <img
                    src={`${
                      currentActivity &&
                      currentActivity.websiteData &&
                      currentActivity.websiteData.aboutClient &&
                      currentActivity.websiteData.aboutClient.data &&
                      currentActivity.websiteData.aboutClient.data.logo
                        ? currentActivity.websiteData.aboutClient.data.logo
                        : "--"
                    }`}
                    alt="software-screen mt-5"
                    // style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};
